import { useRef } from 'react';

import useGsapSection from '../../hooks/useGsapSection';

import { ScrambleReveal } from '../TextEffects';



const CaseStudyProcess = ({

  title = 'Process',

  text,

  paragraphs,

  layout = 'default',

}) => {

  const ref = useRef(null);

  const inView = useGsapSection(ref);



  const copy = paragraphs || (text ? [text] : []);

  if (copy.length === 0) return null;



  return (

    <section

      className={`cs-process${layout === 'narrow' ? ' is-narrow' : ''}`}

      ref={ref}

      data-testid="case-study-process"

    >

      <div className="cs-process-inner gsap-reveal">

        <span className="cs-process-label">

          <ScrambleReveal text={title} externalInView={inView} delay={0.02} />

        </span>

        <div className="cs-process-copy">

          {copy.map((paragraph, i) => (

            <p key={i} className="cs-process-text">

              {paragraph}

            </p>

          ))}

        </div>

      </div>

    </section>

  );

};



export default CaseStudyProcess;

